var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5930_3653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27.7895,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5930_3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5379C11.0347 13.5379 10.21 13.1419 9.526 12.3499C8.842 11.5581 8.5 10.6032 8.5 9.48525C8.5 8.36749 8.842 7.41262 9.526 6.62062C10.21 5.82862 11.0347 5.43262 12 5.43262C12.9653 5.43262 13.79 5.82862 14.474 6.62062C15.158 7.41262 15.5 8.36749 15.5 9.48525C15.5 10.6032 15.158 11.5581 14.474 12.3499C13.79 13.1419 12.9653 13.5379 12 13.5379ZM4.5 20.5967V19.7815C4.5 19.2146 4.633 18.6895 4.899 18.2062C5.165 17.723 5.5205 17.3515 5.9655 17.0917C6.95383 16.5307 7.95092 16.11 8.95675 15.8294C9.96258 15.5488 10.977 15.4085 12 15.4085C13.023 15.4085 14.0374 15.5488 15.0433 15.8294C16.0491 16.11 17.0462 16.5307 18.0345 17.0917C18.4795 17.3515 18.835 17.723 19.101 18.2062C19.367 18.6895 19.5 19.2146 19.5 19.7815V20.5967C19.5 21.0849 19.3523 21.5002 19.0568 21.8426C18.7613 22.1847 18.4026 22.3558 17.9808 22.3558H6.01925C5.59742 22.3558 5.23875 22.1847 4.94325 21.8426C4.64775 21.5002 4.5 21.0849 4.5 20.5967Z",
    fill: "#1774B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.aed37aebe172cb3f361d1fe394c8bc75.svg";
export { ForwardRef as ReactComponent };